package com.milta.core.localization.translations.ro

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Se încarcă…",
    errorNoConnection = "Serverul nu poate fi contactat — verifică-ți conexiunea.",
    errorGeneric = "A apărut o eroare. Încearcă din nou mai târziu.",
    emptyStateMessage = "Nicio dată momentan.",
    kpiTotalDocumentsLabel = "Documente analizate",
    kpiCompletedDocumentsLabel = "Documente complete",
    kpiCompletedDocumentsSubtitle = "simulate pentru cele 4 strategii",
    kpiTotalRealCostLabel = "Cost real total",
    kpiTotalInputTokensLabel = "Jetoane de intrare",
    kpiTotalOutputTokensLabel = "Jetoane de ieșire",
    breakdownByFileKindLabel = "Distribuție",
    fileKindImageLabel = "Imagini",
    fileKindPdfLabel = "PDF-uri",
    fileKindXlsxLabel = "Foi de calcul",
    flowTitle = "Fluxul complet, pas cu pas",
    flowYesLabel = "Da",
    flowNoLabel = "Nu",
    flowStep1Title = "Document trimis",
    flowStep1Subtitle = "Fotografie, PDF sau fișier primit prin aplicație",
    flowStep2Title = "Amprentă unică calculată",
    flowStep2Subtitle = "Se calculează un identificator unic pentru acest document",
    flowStep2Note = "Dacă a mai fost văzut: analiza locală nu se reface (costul real de IA este în continuare contorizat normal, fiind o încărcare reală).",
    flowStep3Title = "Tip de fișier detectat",
    flowStep3Subtitle = "Restul analizei diferă în funcție de tip",
    flowImageBranchTitle = "📷 Dacă este o fotografie",
    flowImageStep1Title = "Verificare calitate",
    flowImageStep1Subtitle = "Claritate, luminozitate, rezoluție, document bine încadrat",
    flowImageStep2Title = "Dacă se consideră calitate insuficientă",
    flowImageStep2Subtitle = "Motivul este înregistrat, dar citirea locală este încercată totuși imediat după",
    flowImageStep3Title = "Corectare înclinare",
    flowImageStep3Subtitle = "Imaginea este îndreptată dacă este detectată o înclinare fiabilă",
    flowImageStep4Title = "Citire locală (gratuită)",
    flowImageStep4Subtitle = "Citirea textului fără IA — franceză, olandeză, engleză",
    flowImageStep5Title = "Scor de fiabilitate",
    flowImageStep5Subtitle = "Scor de la 0 la 100 privind calitatea acestei citiri locale",
    flowPdfBranchTitle = "📄 Dacă este un PDF",
    flowPdfStep1Title = "Text nativ detectat?",
    flowPdfStep1Subtitle = "Verifică dacă PDF-ul conține deja text digital utilizabil",
    flowPdfNote = "Dacă este scanat fără text nativ: fiecare pagină (max. 20) este convertită în imagine și recitită local, la fel ca o fotografie.",
    flowXlsxBranchTitle = "📊 Dacă este o foaie de calcul",
    flowXlsxStep1Title = "Coloane identificate",
    flowXlsxStep1Subtitle = "Recunoaștere automată, sau asistată de IA, a coloanelor (nume, adresă, telefon…)",
    flowXlsxNote = "Structura fișierului (rânduri, coloane, antet) analizată local.",
    flowClaudeTitle = "Apel către IA (Claude)",
    flowClaudeSubtitle = "Astăzi se face întotdeauna un apel real, indiferent de traseul de mai sus — cost real facturat",
    flowSimulationTitle = "🔬 Simulare ulterioară (nu în producție)",
    flowSimulationNote = "Odată colectate datele de mai sus, 4 strategii alternative sunt reluate pe aceleași documente pentru a estima ce ar fi costat în locul apelului sistematic către IA — exact asta compară tabelul de mai jos. Niciuna dintre aceste 4 strategii nu este folosită efectiv în producție astăzi.",
    flowPersistTitle = "Salvat",
    flowPersistSubtitle = "Rezultatul real și cele 4 simulări sunt stocate",
    flowDashboardTitle = "Tablou de bord",
    flowDashboardSubtitle = "Acest ecran agregă rezultatele pe strategie",
    tableTitle = "Comparație a strategiilor posibile",
    columnMode = "Strategie",
    columnDocuments = "Documente",
    columnClaudeCalls = "Apeluri către IA",
    columnProjectedCost = "Cost proiectat",
    columnRealCost = "Cost real",
    columnSavings = "Economie proiectată",
    modeBaseline = "Strategia actuală",
    modeBaselineDescription = "IA este apelată sistematic pentru fiecare document — aceasta este ceea ce se folosește efectiv astăzi în producție.",
    modeMinimal = "Preprocesare ușoară",
    modeMinimalDescription = "Mici optimizări înainte de trimiterea către IA, fără a schimba decizia: IA este întotdeauna apelată, același cost ca strategia actuală.",
    modeTesseractGate = "Citire locală cu recurs la IA",
    modeTesseractGateDescription = "O citire locală gratuită evaluează mai întâi calitatea documentului; IA este apelată doar dacă această citire este considerată insuficientă.",
    modeTesseractOnly = "Doar citire locală",
    modeTesseractOnlyDescription = "Niciun apel către IA — doar o citire locală gratuită, potențial mai puțin fiabilă pe documente de calitate slabă.",
)
